<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title font-weight-bold">{{label}}</h3>
        </div>
        <div class="card-body p-3">
            <div class="title-template-table  table-responsive">
                <table class="table table-hover table-head-fixed table-hover mb-3">
                    <thead>
                        <tr>
                            <!--<th class="text-center">Mã tài liệu</th>-->
                            <th>Tên tài liệu</th>
                            <th>Tóm tắt</th>
                            <!--<th>Tác giả</th>-->
                            <!--                            <th  class="text-center">Năm xuất bản</th>-->
                            <th class="text-right">
                                <span class="btn-add float-right pr-2" @click="create">
                                    <i class="icon16-plus-circle-gadient"></i> Thêm mới
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="!items || !items.length" >
                        <tr>
                            <td colspan="6" class="text-center text-danger">Danh sách tài liệu trống</td>
                        </tr>
                    </tbody>
                    <draggable v-model="items" @change="move" tag="tbody">
                        <tr v-for="(item, index) in items" :key="index" class="tr-draggable">
                            <!--<td class="text-center">{{ item.code.toUpperCase() }}</td>-->
                            <td>{{ item.name }}</td>
                            <td>{{ item.desc }}</td>
                            <!--<td class="text-center"> {{ item.pudlic_year }}</td>-->
                            <td class="text-right">
                                <button type="button" class="btn-sm btn btn-sm btn-outline-gray mr-3">
                                    <i class="fa fa-arrows-alt mr-0"></i>
                                </button>
                        <g-button :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click='update(index)'/>
                        <g-button :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1" icon="trash-fill" @click='del(index)' />
                        </td>
                        </tr>
                    </draggable>
                </table>
            </div>
        </div>
        <b-modal v-model="showForm" :title="`${formTitle} ${label}`" no-close-on-backdrop no-enforce-focus>
            <!--<form-input  :required='true'  label="Mã tài liệu" :model="formModel" attribute="code" :errors="formErrors"></form-input>-->
            <form-input  :required='true' label="Tên tài liệu" :model="formModel" attribute="name" :errors="formErrors"></form-input>
            <!--<form-input   :required='true' label="Tác giả" :model="formModel" attribute="author" :errors="formErrors"></form-input>-->
            <!--<form-input label="Năm xuất bản" :model="formModel" type="number" attribute="pudlic_year" :errors="formErrors"></form-input>-->
            <form-textarea label="Tóm tắt tài liệu" :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
            <form-media :model="formModel" :required='true' label="Tài liệu đính kèm" attribute="file_id" placeholder="Chọn tài liệu" :errors="formErrors" />

            <template v-slot:modal-footer>
                <b-button variant="secondary" class="float-right" @click="showForm = false">Huỷ</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import crud from '@/mixins/CRUD';
    import FormMedia from '@/components/media/FormMedia';

    export default {
        mixins: [crud],
        components: {draggable, FormMedia},
        props: ['model', 'attribute', 'label'],
        data() {
            return {
                defaultFormModel: {
                    code: null,
                    name: null,
                    author: null,
                    category: null,
                    desc: null,
                    file_id: null,
                    position: 1,
                },
                items: this.model[this.attribute] ? this.model[this.attribute] : [],
                state: null,
                errorTxt: '',
                formErrors: {},
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    if (val[this.attribute] && val[this.attribute] !== null) {
                        this.items = val[this.attribute];
                    } else {
                        this.items = null;
                    }
                }, deep: true
            },
            items(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            validators: function () {
                this.formErrors = {};
//                let regexKey = /^([a-zA-Z0-9-_]*)$/;
//                if (this.formModel.pudlic_year != undefined && this.formModel.pudlic_year !== null && this.formModel.pudlic_year !== '') {
//                    if (!Number.isInteger(Number(this.formModel.pudlic_year)) || 1000 > this.formModel.pudlic_year || this.formModel.pudlic_year > 9999) {
//                        this.formErrors.pudlic_year = ["Năm xuất bản không đúng định dạng yyyy "];
//                    }
//                }
                if (this.formModel.desc !== null && this.formModel.desc !== '') {
                    if (this.formModel.desc.length > 500) {
                        this.formErrors.desc = ["Tóm tắt tài liệu không được quá 500 ký tự"];
                    }
                }
                if (this.formModel.name === null || this.formModel.name === '') {
                    this.formErrors.name = ["Tên tài liệu không được để trống"];
                } else {
                    let cf = this.items.find(item => {
                        return  item.code !== this.formModel.code && item.name === this.formModel.name;
                    });
                    if (typeof (cf) !== 'undefined') {
                        this.formErrors.name = ["Tên tài liệu đã được sử dụng"];
                    }
                    if (this.formModel.name.length > 250) {
                        this.formErrors.name = ["Tên tài liệu không được quá 250 ký tự"];
                    }
                }
//                if (this.formModel.code === null || this.formModel.code === '') {
//                    this.formErrors.code = ["Mã tài liệu không được để trống"];
//                } else if (!regexKey.test(this.formModel.code)) {
//                    this.formErrors.code = ["Mã tài liệu không đúng định dạng"];
//                } else if (this.formModel.code.length > 50) {
//                    this.formErrors.code = ["Mã tài liệu không được quá 50 ký tự"];
//                } else if (!this.formModel.id) {
//                    let cf = this.items.find(item => {
//                        return item.code === this.formModel.code;
//                    });
//                    if (typeof (cf) !== 'undefined') {
//                        this.formErrors.code = ["Mã tài liệu được sử dụng"];
//                    }
//                }
                if (!this.formModel.file_id) {
                    this.formErrors.file_id = ["Tài liệu không được để trống"];
                }
            },
            save: function (evt) {
                this.items = !this.items || !this.items.length ? [] : this.items;
                evt.preventDefault();
                this.validators();
                if (Object.keys(this.formErrors).length > 0) {
                    return false;
                }
                if (!this.formModel.id) {
                    this.items.push(this.formModel);
                }
                this.showForm = false;

            },
            move: function () {

            },
            update: function (index) {
                this.formModel = {};
                this.formTitle = "Cập nhật";
                this.formErrors = [];
                this.showForm = true;
                this.formModel = this.items[index];
                this.formModel.id = `${index}`;
            },
            del: function (index) {
                this.$swal({
                    title: "Bạn chắc chắn muốn xóa chứ?",
                    text: "Sẽ không thể khôi phục lại dữ liệu đã xóa!",
                    icon: "warning",
                    showCancelButton: true
                }).then((result) => {
                    if (result.value) {
                        if (result.value) {
//                            let index = this.items.findIndex(item => {
//                                return item.code === code;
//                            });
                            this.items.splice(index, 1);
                        }
                    }
                });
            },
        }
    }
</script>